import request from '../utils/request';

const commentApi = {
  // 分页获取评论列表
  pageComments: (params) => {
    return request.get('/comments/page', { 
      params: {
        page: 1,
        pageSize: 10,
        childCommentLimit: 3,
        ...params
      }
    });
  },

  // 添加评论
  addComment: (data) => {
    return request.post('/comments', data);
  },

  // 删除评论
  deleteComment: (commentId) => {
    return request.delete(`/comments/${commentId}`);
  }
};

export default commentApi;
